import { render, staticRenderFns } from "./ReviewSendOfferMessageModal.vue?vue&type=template&id=724cc23b&scoped=true"
import script from "./ReviewSendOfferMessageModal.vue?vue&type=script&lang=js"
export * from "./ReviewSendOfferMessageModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewSendOfferMessageModal.vue?vue&type=style&index=0&id=724cc23b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724cc23b",
  null
  
)

export default component.exports